<template>
  <el-form
    ref="ruleFormRef"
    class="insured-dialog-form account-person-form account-person-form--split account-person-form--update"
    label-position="top"
    :rules="rules"
    :model="values"
    @submit.prevent
  >
    <div class="account-person-form__main">
      <div class="account-person-form__layout">
        <div class="account-person-form__col">
          <h3 class="account-person-form__title">{{ $t("commonIdCard") }}</h3>
          <div class="account-person-form__row account-person-form__row--3">
            <el-form-item
              label="PIN"
              prop="pin"
              :class="{ 'insured-update-field--changed': isFieldChanged('pin') }"
            >
              <el-input v-model="values.pin" maxlength="7" class="uppercase-input" />
              <InsuredUpdateFieldHint :diff="fieldDiff('pin')" />
            </el-form-item>
            <el-form-item
              :label="$t('commonSex')"
              prop="sex"
              :class="{ 'insured-update-field--changed': isFieldChanged('sex') }"
            >
              <el-select v-model="values.sex" :placeholder="$t('commonSelect')">
                <el-option
                  v-for="item in sexOptions"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                />
              </el-select>
              <InsuredUpdateFieldHint :diff="fieldDiff('sex')" />
            </el-form-item>
            <el-form-item
              :label="$t('commonBirthDate')"
              prop="dob"
              :class="{ 'insured-update-field--changed': isFieldChanged('dob') }"
            >
              <el-date-picker
                v-model="values.dob"
                style="width: 100%"
                type="date"
                format="DD.MM.YYYY"
                placeholder="dd.mm.yyyy"
              />
              <InsuredUpdateFieldHint :diff="fieldDiff('dob')" />
            </el-form-item>
          </div>

          <h3 class="account-person-form__title account-person-form__title--gap">{{ $t("commonGeneralInfo") }}</h3>
          <div class="account-person-form__row account-person-form__row--3">
            <el-form-item
              :label="$t('commonName')"
              prop="firstName"
              :class="{ 'insured-update-field--changed': isFieldChanged('firstName') }"
            >
              <el-input v-model="values.firstName" class="uppercase-input" />
              <InsuredUpdateFieldHint :diff="fieldDiff('firstName')" />
            </el-form-item>
            <el-form-item
              :label="$t('commonLastName')"
              prop="lastName"
              :class="{ 'insured-update-field--changed': isFieldChanged('lastName') }"
            >
              <el-input v-model="values.lastName" class="uppercase-input" />
              <InsuredUpdateFieldHint :diff="fieldDiff('lastName')" />
            </el-form-item>
            <el-form-item
              :label="$t('commonMiddleName')"
              prop="middleName"
              :class="{ 'insured-update-field--changed': isFieldChanged('middleName') }"
            >
              <el-input v-model="values.middleName" class="uppercase-input" />
              <InsuredUpdateFieldHint :diff="fieldDiff('middleName')" />
            </el-form-item>
          </div>
        </div>

        <div class="account-person-form__col account-person-form__col--right">
          <h3 class="account-person-form__title">{{ $t("commonContact") }}</h3>
          <el-form-item
            :label="$t('commonPhone')"
            prop="phone"
            :class="{ 'insured-update-field--changed': isFieldChanged('phone') }"
          >
            <AzPhoneInput v-model="values.phone" />
            <InsuredUpdateFieldHint :diff="fieldDiff('phone')" />
          </el-form-item>
          <el-form-item
            :label="$t('commonAddress')"
            :class="{ 'insured-update-field--changed': isFieldChanged('address') }"
          >
            <el-input v-model="values.address" />
            <InsuredUpdateFieldHint :diff="fieldDiff('address')" />
          </el-form-item>

          <h3 class="account-person-form__title account-person-form__title--gap">{{ $t("commonNotes") }}</h3>
          <el-form-item
            class="account-person-form__notes-field"
            :class="{ 'insured-update-field--changed': isFieldChanged('descr') }"
          >
            <el-input
              v-model="values.descr"
              type="textarea"
              :rows="3"
              :placeholder="$t('commonExtraNotes')"
              resize="none"
            />
            <InsuredUpdateFieldHint :diff="fieldDiff('descr')" />
          </el-form-item>
        </div>
      </div>
    </div>

    <div class="insured-dialog-footer">
      <button type="button" class="insured-dialog-btn insured-dialog-btn--muted" @click="close">
        {{ $t("commonCancel") }}
      </button>
      <button type="button" class="insured-dialog-btn insured-dialog-btn--primary" @click="submitForm">
        {{ !values.editing ? $t("commonInsert") : $t("commonAccept") }}
      </button>
    </div>
  </el-form>
</template>

<script>
import { getCardId } from "@/project/Source/routes";
import Source from "../../Source/claim.js";
import CryptoJS from "crypto-js";
import {
  formatAzMobileFull,
  normalizeAzMobilePhone,
  parseAzMobileDigits,
} from "../../Source/helper.js";
import AzPhoneInput from "../../Global/Components/AzPhoneInput.vue";
import InsuredUpdateFieldHint from "./InsuredUpdateFieldHint.vue";

export default {
  name: "InsuredAllDialog",
  components: {
    AzPhoneInput,
    InsuredUpdateFieldHint,
  },
  props: {
    cancel: Boolean,
    info: Object,
  },
  data() {
    return {
      values: {},
      rules: {
        phone: [{ required: true, validator: this.phoneCheck, trigger: "change" }],
        firstName: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        pin: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        dob: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        middleName: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        sex: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
        lastName: [{ required: true, message: "Mütləq sahə", trigger: "change" }],
      },
      old: null,
      oldLoaded: false,
      statusOptions: [],
      sexOptions: [],
    };
  },
  computed: {
    fieldMetaList() {
      if (!this.oldLoaded || !this.old) return [];

      return [
        {
          key: "pin",
          newVal: this.values.pin,
          oldVal: this.old.pin,
          newDisplay: this.displayText(this.values.pin),
          oldDisplay: this.displayText(this.old.pin),
        },
        {
          key: "sex",
          newVal: this.values.sex,
          oldVal: this.old.sex,
          newDisplay: this.displaySex(this.values.sex),
          oldDisplay: this.displaySex(this.old.sex),
        },
        {
          key: "dob",
          newVal: this.normalizeDob(this.values.dob),
          oldVal: this.normalizeDob(this.old.dob),
          newDisplay: this.displayDob(this.values.dob),
          oldDisplay: this.displayDob(this.old.dob),
        },
        {
          key: "firstName",
          newVal: this.values.firstName,
          oldVal: this.old.firstName,
          newDisplay: this.displayText(this.values.firstName),
          oldDisplay: this.displayText(this.old.firstName),
        },
        {
          key: "lastName",
          newVal: this.values.lastName,
          oldVal: this.old.lastName,
          newDisplay: this.displayText(this.values.lastName),
          oldDisplay: this.displayText(this.old.lastName),
        },
        {
          key: "middleName",
          newVal: this.values.middleName,
          oldVal: this.old.middleName,
          newDisplay: this.displayText(this.values.middleName),
          oldDisplay: this.displayText(this.old.middleName),
        },
        {
          key: "phone",
          newVal: this.normalizePhone(this.values.phone),
          oldVal: this.normalizePhone(this.old.phone),
          newDisplay: this.displayPhone(this.values.phone),
          oldDisplay: this.displayPhone(this.old.phone),
        },
        {
          key: "address",
          newVal: this.values.address,
          oldVal: this.old.address,
          newDisplay: this.displayText(this.values.address),
          oldDisplay: this.displayText(this.old.address),
        },
        {
          key: "descr",
          newVal: this.values.descr,
          oldVal: this.old.descr,
          newDisplay: this.displayText(this.values.descr),
          oldDisplay: this.displayText(this.old.descr),
        },
      ];
    },
    changedFields() {
      return this.fieldMetaList.filter((field) => !this.isSameValue(field.newVal, field.oldVal));
    },
  },
  mounted() {
    this.values = {
      ...this.info,
      phone: this.phoneLocal(this.info?.phone),
    };
    this.old = { ...this.info };
    this.oldLoaded = true;
    this.statusOptions = [
      { value: true, text: "işçi" },
      { value: false, text: "ailə üzvü" },
    ];
    this.sexOptions = [
      { value: "m", text: "kişi" },
      { value: "f", text: "qadın" },
    ];
    const cardId = this.info?.cardId || getCardId(this.$route);
    if (cardId) {
      const data = {
        id: cardId,
        requestCorrelationId: "string",
      };
      Source.PolicyCardByCard(data).then((response) => {
        if (response.data?.data?.[0]) {
          this.old = response.data.data[0];
          this.oldLoaded = true;
        }
      });
    }
  },
  methods: {
    fieldDiff(key) {
      const field = this.fieldMetaList.find((item) => item.key === key);
      if (!field || this.isSameValue(field.newVal, field.oldVal)) {
        return null;
      }
      return {
        oldDisplay: field.oldDisplay,
        newDisplay: field.newDisplay,
      };
    },
    isFieldChanged(key) {
      return this.changedFields.some((field) => field.key === key);
    },
    isSameValue(newVal, oldVal) {
      const left = newVal == null ? "" : String(newVal).trim();
      const right = oldVal == null ? "" : String(oldVal).trim();
      return left === right;
    },
    displayText(value) {
      const text = value == null ? "" : String(value).trim();
      return text || this.$t("commonNotAvailable");
    },
    displaySex(value) {
      const option = this.sexOptions.find((item) => item.value === value);
      return option?.text || this.displayText(value);
    },
    normalizeDob(value) {
      if (!value) return "";
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return String(value).trim();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },
    displayDob(value) {
      if (!value) return this.$t("commonNotAvailable");
      const date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return this.displayText(value);
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      return `${day}.${month}.${date.getFullYear()}`;
    },
    displayPhone(value) {
      const formatted = formatAzMobileFull(value);
      return formatted || this.$t("commonNotAvailable");
    },
    phoneLocal(value) {
      return parseAzMobileDigits(value);
    },
    normalizePhone(value) {
      return normalizeAzMobilePhone(value);
    },
    submitForm() {
      this.$refs.ruleFormRef.validate((valid) => {
        if (valid) {
          const realDate = this.values.dob;
          let appDate = null;
          if (realDate != this.info.dob) {
            var year = realDate.getFullYear();
            var month = ("0" + (realDate.getMonth() + 1)).slice(-2);
            var day = ("0" + realDate.getDate()).slice(-2);
            var hours = ("0" + realDate.getHours()).slice(-2);
            var minutes = ("0" + realDate.getUTCMinutes()).slice(-2);
            var seconds = ("0" + realDate.getUTCSeconds()).slice(-2);
            var milliseconds = ("00" + realDate.getUTCMilliseconds()).slice(-3);

            appDate =
              year +
              "-" +
              month +
              "-" +
              day +
              "T" +
              hours +
              ":" +
              minutes +
              ":" +
              seconds +
              "." +
              milliseconds +
              "Z";
          } else {
            appDate = realDate;
          }

          let userId = 1;
          try {
            const rawUser = window.localStorage.getItem("user");
            if (rawUser) {
              userId = JSON.parse(CryptoJS.AES.decrypt(rawUser, "secret_key").toString(CryptoJS.enc.Utf8)).userId;
            }
          } catch (e) {
            userId = 1;
          }

          const bulkPayload = {
            requestCorrelationId: "string",
            policyId: Number(this.info.policyId),
            operType: 4,
            groupId: this.old.groupId || null,
            effectiveDate: new Date(),
            descr: this.values.descr || "Məlumat dəyişikliyi",
            createUser: userId || 1,
            items: [
              {
                cardId: this.info.cardId,
                cardFullNumber: this.info.cardFullNumber || this.old.cardFullNumber,
                pin: this.values.pin,
                firstName: this.values.firstName,
                lastName: this.values.lastName,
                middleName: this.values.middleName,
                dob: appDate ? new Date(appDate) : null,
                sex: this.values.sex,
                phone: this.normalizePhone(this.values.phone),
                address: this.values.address,
                isEmployee: this.old.isEmployee,
                vip: this.info.vip,
                oldGroupId: this.old.groupId,
                oldGroupName: this.old.groupName,
                newGroupId: this.old.groupId,
                newGroupName: this.old.groupName,
                startDate: null,
                endDate: null,
              },
            ],
          };

          Source.AccountRequestBulkInsert(bulkPayload).then(() => {
            this.$emit("custom-event", 1);
          });
        }
      });
    },
    close() {
      this.$emit("custom-event", 0);
    },
    disabledDate(time) {
      var dayInMillis = 24 * 60 * 60 * 1000;
      return time.getTime() <= new Date() - dayInMillis;
    },
    phoneCheck(rule, value, callback) {
      if (!value) {
        return callback(new Error("Mütləq sahə"));
      }
      setTimeout(() => {
        const phone = this.normalizePhone(this.values.phone);
        const rightSecond = phone[3] + phone[4];
        const validPrefix =
          rightSecond === "50" ||
          rightSecond === "55" ||
          rightSecond === "70" ||
          rightSecond === "77" ||
          rightSecond === "10" ||
          rightSecond === "99";
        if (phone.length === 12 && validPrefix) {
          return callback();
        }
        return callback(new Error("Səhf məlumat"));
      }, 300);
    },
  },
};
</script>

<style scoped>
.uppercase-input :deep(.el-input__inner) {
  text-transform: uppercase;
}
</style>
